import {
	FILTERED_PROMO_ICONS,
	PRODUCT_CARD_PROMO_ICONS,
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE,
} from '@/data/constants/promoIconConstants';

import { useSettings } from '@/data/Settings';
import { ResponseProductAttribute } from '@/data/types/Product';
import { validateStoreExclude } from '@/data/utils/validateStoreExclude';

export const findPromoIconsFromAttributeByStoreAndMarketId = (
	attributes: ResponseProductAttribute[],
	isB2B: boolean,
	currentMarketId: string
): ResponseProductAttribute[] => {
	if (attributes && attributes.length > 0) {
		let promoIcons: Array<string> = [];
		if (isB2B) {
			promoIcons = PRODUCT_CARD_PROMO_ICONS.B2B;
		} else {
			promoIcons = PRODUCT_CARD_PROMO_ICONS.B2C;
		}

		const allPromoIcons = attributes.filter(
			(attr: ResponseProductAttribute) =>
				promoIcons.includes(attr.identifier) &&
				((isB2B && PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE.B2B.includes(attr.identifier)) ||
				(!isB2B && PRODUCT_CARD_PROMO_ICONS_VALIDATE_STORE_EXCLUDE.B2C.includes(attr.identifier))
					? validateStoreExclude(attr, currentMarketId)
					: true)
		);

		return allPromoIcons ?? [];
	} else {
		return [];
	}
};

export const useRibbonURLs = (): Record<string, string> => {
	const { settings } = useSettings();
	const imageCDNHostName = settings.userData.IMAGE_SERVER_HOSTNAME || '';

	const updatedPromoIcons = Object.entries(PRODUCT_CARD_PROMO_ICONS_IMG_URL).reduce(
		(acc, [key, value]) => {
			acc[key] = value ? `${imageCDNHostName}${value}` : value;
			return acc;
		},
		{} as Record<string, string>
	);

	return updatedPromoIcons;
};

/**
 * Filter the promo attributes by pre-defined list and sort.
 * @param promoIcons
 * @returns
 */
export const filterAndOrderPromoIcons = (promoIcons: ResponseProductAttribute[]) => {
	if (promoIcons) {
		const orderedRibbons = promoIcons
			.map((item) => (FILTERED_PROMO_ICONS.includes(item.identifier) ? item : null))
			.filter((item): item is ResponseProductAttribute => Boolean(item));

		orderedRibbons.sort((a, b) => {
			if (!a || !b) return 0;
			if (!a) return 1; // push `a` to the end
			if (!b) return -1; // push `b` to the end

			const indexA = FILTERED_PROMO_ICONS.indexOf(a.identifier);
			const indexB = FILTERED_PROMO_ICONS.indexOf(b.identifier);
			return indexA - indexB;
		});
		return orderedRibbons as ResponseProductAttribute[];
	}

	return [];
};
